module.exports = __webpack_public_path__ + "img/car_shina2_40.91f71695.jpg";